export default __webpack_public_path__ + "static/media/saloni.0343dcc4.webp";